import UserPerGroup from '../userPerGroup';
import './style.scss';

function UserItem({ groupData }) {
  return (
    <div className='head-main-container'>
      <div className='descriptionHead-container'>
        <p className='head'>Documento de identidad</p>
        <p className='head nameD'>Nombre del beneficiario</p>
      </div>
      {groupData.length > 0 &&
        groupData.map((user, i) => <UserPerGroup key={i} user={user} />)}
    </div>
  );
}

export default UserItem;
